var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('ul',{staticStyle:{"padding-top":"20px","background-color":"white"}},_vm._l((_vm.incidencias),function(inci){return _c('li',{staticStyle:{"margin-bottom":"15px"}},[_c('pre',[_vm._v(_vm._s(inci.issues))])])}),0)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-55dfae8b","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Dashboard/Informes/Ventas/Widgets/Incidencias.vue
// module id = E3VH
// module chunks = 4